import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSchedulingWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25.828,
	height: 30.132,
	viewBox: "0 0 25.828 30.132",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_3034",
		"data-name": "Group 3034",
		transform: "translate(456 -499)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_5277",
			"data-name": "Path 5277",
			d: "M24.088,3.87H19.525a4.288,4.288,0,0,0-8.093,0H6.87A2.878,2.878,0,0,0,4,6.739V28.262a2.878,2.878,0,0,0,2.87,2.87h8.767a9.676,9.676,0,0,1-2.038-2.87H6.87V6.739h2.87V8.174a2.878,2.878,0,0,0,2.87,2.87h5.739a2.878,2.878,0,0,0,2.87-2.87V6.739h2.87v7.289a10.088,10.088,0,0,1,2.87.861V6.739A2.878,2.878,0,0,0,24.088,3.87Zm-8.609,2.87A1.435,1.435,0,1,1,16.914,5.3,1.439,1.439,0,0,1,15.479,6.739Zm7.174,10.044a7.174,7.174,0,1,0,7.174,7.174A7.177,7.177,0,0,0,22.653,16.784ZM24.5,26.828,22.137,24.46a.731.731,0,0,1-.215-.5V20.385a.71.71,0,0,1,.717-.717h0a.71.71,0,0,1,.717.717v3.286l2.152,2.152a.71.71,0,0,1,0,1.019h0A.706.706,0,0,1,24.5,26.828Z",
			transform: "translate(-460 498)"
		})
	})
});
export { SvgSchedulingWhite as ReactComponent };
